import { CareGiver, CareGiverCovergaeAvailability, CareGiverFormData, CaregiverNationality, CareGiverNightTime, CareGiverOtherPeoplePresence, CareGiverPeronality, CareGiverSmokes, CareGiverWeekendAvailability, CareGiverYearsOfExperience } from "../types/caregivers";

export const CAREGIVER_SWEET_PERSONALITY = 'Dolce' as const;
export const CAREGIVER_EMPATHIC_PERSONALITY = 'Empatica' as const;
export const CAREGIVER_HELPFUL_PERSONALITY = 'Disponibile' as const;
export const CAREGIVER_CHEERFUL_PERSONALITY = 'Solare' as const;
export const CAREGIVER_KIND_PERSONALITY = 'Gentile' as const;
export const CAREGIVER_UNDERSTANDING_PERSONALITY = 'Comprensiva' as const;
export const CAREGIVER_PATIENT_PERSONALITY = 'Paziente' as const;
export const CAREGIVER_PRECISE_PERSONALITY = 'Precisa' as const;
export const CAREGIVER_AUTHORITATIVE_PERSONALITY = 'Autoritaria' as const;
export const CAREGIVER_STRONG_PERSONALITY = 'Carattere forte' as const;
export const CAREGIVER_COLD_PERSONALITY = 'Fredda' as const;
export const CAREGIVER_ARROGANT_PERSONALITY = 'Arrogante' as const;
export const CAREGIVER_RUDE_PERSONALITY = 'Maleducata' as const;
export const CAREGIVER_HAUGHTY_PERSONALITY = 'Altezzosa' as const;
export const CAREGIVER_OVERBEARING_PERSONALITY = 'Prepotente' as const;
export const CAREGIVER_SMOKE_PERSONALITY = 'Fumatrice' as const;
export const CAREGIVER_PERSONALITIES = [
  CAREGIVER_SWEET_PERSONALITY,
  CAREGIVER_EMPATHIC_PERSONALITY,
  CAREGIVER_HELPFUL_PERSONALITY,
  CAREGIVER_CHEERFUL_PERSONALITY,
  CAREGIVER_KIND_PERSONALITY,
  CAREGIVER_UNDERSTANDING_PERSONALITY,
  CAREGIVER_PATIENT_PERSONALITY,
  CAREGIVER_PRECISE_PERSONALITY,
  CAREGIVER_AUTHORITATIVE_PERSONALITY,
  CAREGIVER_STRONG_PERSONALITY,
  CAREGIVER_COLD_PERSONALITY,
  CAREGIVER_ARROGANT_PERSONALITY,
  CAREGIVER_RUDE_PERSONALITY,
  CAREGIVER_HAUGHTY_PERSONALITY,
  CAREGIVER_OVERBEARING_PERSONALITY,
  //CAREGIVER_SMOKE_PERSONALITY,
] as const;

export const CARE_GIVER_PERSONALITIES_SELECTOR_DATA: {
  key: CareGiverPeronality;
  value: CareGiverPeronality;
}[] = [
  { key: CAREGIVER_SWEET_PERSONALITY, value: CAREGIVER_SWEET_PERSONALITY },
  { key: CAREGIVER_EMPATHIC_PERSONALITY, value: CAREGIVER_EMPATHIC_PERSONALITY },
  { key: CAREGIVER_HELPFUL_PERSONALITY, value: CAREGIVER_HELPFUL_PERSONALITY },
  { key: CAREGIVER_CHEERFUL_PERSONALITY, value: CAREGIVER_CHEERFUL_PERSONALITY },
  { key: CAREGIVER_KIND_PERSONALITY, value: CAREGIVER_KIND_PERSONALITY },
  { key: CAREGIVER_UNDERSTANDING_PERSONALITY, value: CAREGIVER_UNDERSTANDING_PERSONALITY },
  { key: CAREGIVER_PATIENT_PERSONALITY, value: CAREGIVER_PATIENT_PERSONALITY },
  { key: CAREGIVER_PRECISE_PERSONALITY, value: CAREGIVER_PRECISE_PERSONALITY },
  { key: CAREGIVER_AUTHORITATIVE_PERSONALITY, value: CAREGIVER_AUTHORITATIVE_PERSONALITY },
  { key: CAREGIVER_STRONG_PERSONALITY, value: CAREGIVER_STRONG_PERSONALITY },
  { key: CAREGIVER_COLD_PERSONALITY, value: CAREGIVER_COLD_PERSONALITY },
  { key: CAREGIVER_ARROGANT_PERSONALITY, value: CAREGIVER_ARROGANT_PERSONALITY },
  { key: CAREGIVER_RUDE_PERSONALITY, value: CAREGIVER_RUDE_PERSONALITY },
  { key: CAREGIVER_HAUGHTY_PERSONALITY, value: CAREGIVER_HAUGHTY_PERSONALITY },
  { key: CAREGIVER_OVERBEARING_PERSONALITY, value: CAREGIVER_OVERBEARING_PERSONALITY },
  //{ key: CAREGIVER_SMOKE_PERSONALITY, value: CAREGIVER_SMOKE_PERSONALITY },
];

export const CAREGIVER_ITALIAN_NATIONALITY = 'Italiana' as const;
export const CAREGIVER_ROMANIAN_NATIONALITY = 'Rumena' as const;
export const CAREGIVER_UKRAINE_NATIONALITY = 'Ucraina' as const;
export const CAREGIVER_MOLDAVIAN_NATIONALITY = 'Moldava' as const;
export const CAREGIVER_RUSSIAN_NATIONALITY = 'Russa' as const;
export const CAREGIVER_ASIAN_NATIONALITY = 'Asiatica' as const;
export const CAREGIVER_AFRICAN_NATIONALITY = 'Africa' as const;
export const CAREGIVER_NORTH_AFRICAN_NATIONALITY = 'Nord Africa' as const;
export const CAREGIVER_EAST_EUROPE_NATIONALIITY = 'Est Europa' as const;
export const CAREGIVER_SOUTH_AMERICA_NATIONALITY = 'Sudamericana' as const;
export const CAREGIVER_ALBANIA_NATIONALITY = 'Albania' as const;
export const CAREGIVER_NATIONALITIES = [
  CAREGIVER_ITALIAN_NATIONALITY,
  CAREGIVER_ROMANIAN_NATIONALITY,
  CAREGIVER_UKRAINE_NATIONALITY,
  CAREGIVER_MOLDAVIAN_NATIONALITY,
  CAREGIVER_RUSSIAN_NATIONALITY,
  CAREGIVER_ASIAN_NATIONALITY,
  CAREGIVER_AFRICAN_NATIONALITY,
  CAREGIVER_NORTH_AFRICAN_NATIONALITY,
  CAREGIVER_EAST_EUROPE_NATIONALIITY,
  CAREGIVER_SOUTH_AMERICA_NATIONALITY,
  CAREGIVER_ALBANIA_NATIONALITY,
] as const;

export const CAREGIVER_NATIONALITIES_SELECTOR_DATA: {
  key: CaregiverNationality;
  value: CaregiverNationality
}[] = [
  { key: CAREGIVER_ITALIAN_NATIONALITY, value: CAREGIVER_ITALIAN_NATIONALITY },
  { key: CAREGIVER_ROMANIAN_NATIONALITY, value: CAREGIVER_ROMANIAN_NATIONALITY },
  { key: CAREGIVER_UKRAINE_NATIONALITY, value: CAREGIVER_UKRAINE_NATIONALITY },
  { key: CAREGIVER_MOLDAVIAN_NATIONALITY, value: CAREGIVER_MOLDAVIAN_NATIONALITY },
  { key: CAREGIVER_RUSSIAN_NATIONALITY, value: CAREGIVER_RUSSIAN_NATIONALITY },
  { key: CAREGIVER_ASIAN_NATIONALITY, value: CAREGIVER_ASIAN_NATIONALITY },
  { key: CAREGIVER_AFRICAN_NATIONALITY, value: CAREGIVER_AFRICAN_NATIONALITY },
  { key: CAREGIVER_NORTH_AFRICAN_NATIONALITY, value: CAREGIVER_NORTH_AFRICAN_NATIONALITY },
  { key: CAREGIVER_EAST_EUROPE_NATIONALIITY, value: CAREGIVER_EAST_EUROPE_NATIONALIITY },
  { key: CAREGIVER_SOUTH_AMERICA_NATIONALITY, value: CAREGIVER_SOUTH_AMERICA_NATIONALITY },
  { key: CAREGIVER_ALBANIA_NATIONALITY, value: CAREGIVER_ALBANIA_NATIONALITY },
];

/* export const CARE_GIVER_YEARS_OF_EXPERIENCE: {
  key: CareGiverYearsOfExperience;
  value: CareGiverYearsOfExperience;
}[] = [
  { key: '5', value: '5' },
  { key: '10', value: '10' },
  { key: '15', value: '15' },
  { key: '20', value: '20' },
] */

export const CAREGIVERS_NIGHT_TIME: {
  key: CareGiverNightTime;
  value: string;
}[] = [
  { key: '0', value: 'Sì' },
  { key: '1', value: 'No' },
  { key: '2', value: 'Non più di due o tre volte a settimana' },
  { key: '3', value: 'Non serve' },
];

export const CAREGIVER_WEEKEND_AVAILABILIY: {
  key: CareGiverWeekendAvailability;
  value: string;
}[] = [
  { key: '0', value: 'Sì' },
  { key: '1', value: 'No' },
  { key: '2', value: 'Non sempre' },
  { key: '3', value: 'Non serve' },
];

export const CAREGIVER_SMOKES: {
  key: CareGiverSmokes;
  value: string;
}[] = [
  { key: '0', value: 'Sì' },
  { key: '1', value: 'No' },
  { key: '2', value: 'Solo ogni tanto' },
];

export const CAREGIVER_OTHER_PEOPLE_PRESENCE: {
  key: CareGiverOtherPeoplePresence;
  value: string;
}[] = [
  { key: '0', value: 'Sì' },
  { key: '1', value: 'No' },
  { key: '2', value: 'Vive solo' },
];

export const CAREGIVER_COVERAGE_AVAILABILITY: {
  key: CareGiverCovergaeAvailability;
  value: string;
}[] = [
  { key: '0', value: 'Badante convivente h24' },
  { key: '1', value: 'Diurno ad ore' },
  { key: '2', value: 'Notturno' },
  { key: '3', value: 'Copertura nei week end'},
];

export const CAREGIVER_PERSONALITIES_POSITIVENESS: Record<CareGiverPeronality, boolean> = {
  [CAREGIVER_SWEET_PERSONALITY]: true,
  [CAREGIVER_EMPATHIC_PERSONALITY]: true,
  [CAREGIVER_HELPFUL_PERSONALITY]: true,
  [CAREGIVER_CHEERFUL_PERSONALITY]: true,
  [CAREGIVER_KIND_PERSONALITY]: true,
  [CAREGIVER_UNDERSTANDING_PERSONALITY]: true,
  [CAREGIVER_PATIENT_PERSONALITY]: true,
  [CAREGIVER_PRECISE_PERSONALITY]: true,
  [CAREGIVER_AUTHORITATIVE_PERSONALITY]: false,
  [CAREGIVER_STRONG_PERSONALITY]: false,
  [CAREGIVER_COLD_PERSONALITY]: false,
  [CAREGIVER_ARROGANT_PERSONALITY]: false,
  [CAREGIVER_RUDE_PERSONALITY]: false,
  [CAREGIVER_HAUGHTY_PERSONALITY]: false,
  [CAREGIVER_OVERBEARING_PERSONALITY]: false,
  //[CAREGIVER_SMOKE_PERSONALITY]: false,
};